export default "__VITE_ASSET__a2dd1f03__"